import { render, staticRenderFns } from "./DealerUsers.vue?vue&type=template&id=706c2718&scoped=true&"
import script from "./DealerUsers.vue?vue&type=script&lang=js&"
export * from "./DealerUsers.vue?vue&type=script&lang=js&"
import style0 from "./DealerUsers.vue?vue&type=style&index=0&id=706c2718&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706c2718",
  null
  
)

export default component.exports